import React, { useState } from 'react';
import { FiX, FiSave, FiLoader } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useCreateInterest } from '../../hooks/useInterests';
import Input from '../Input';

const AddInterest = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    interest: {
      ar: 'dsada',
      en: ''
    }
  });
  const [errors, setErrors] = useState({});

  const createInterestMutation = useCreateInterest();

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      interest: {
        ...prev.interest,
        [field]: value
      }
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.interest.en.trim()) {
      newErrors.en = 'English interest is required';
    }

    if (!formData.interest.ar.trim()) {
      newErrors.ar = 'Arabic interest is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      await createInterestMutation.mutateAsync(formData);
      
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Interest created successfully.',
        timer: 2000,
        showConfirmButton: false,
        background: '#ffffff',
        color: '#333',
        customClass: {
          popup: 'rounded-lg shadow-xl',
        }
      });

      onClose();
    } catch (error) {
      console.error('Error creating interest:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to create interest. Please try again.',
        confirmButtonText: 'OK',
        background: '#ffffff',
        color: '#333',
        customClass: {
          popup: 'rounded-lg shadow-xl',
        }
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-500 opacity-75" onClick={onClose}></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>

        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-900">Add New Interest</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FiX className="h-6 w-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Input
                label="Interest"
                name="interest_en"
                value={formData.interest.en}
                onChange={(e) => handleInputChange('en', e.target.value)}
                error={errors.en}
                placeholder="Enter interest"
                required
              />
            </div>


            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                disabled={createInterestMutation.isPending}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={createInterestMutation.isPending}
                className="px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
              >
                {createInterestMutation.isPending ? (
                  <>
                    <FiLoader className="animate-spin h-4 w-4 mr-2" />
                    Creating...
                  </>
                ) : (
                  <>
                    <FiSave className="h-4 w-4 mr-2" />
                    Create Interest
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddInterest; 